import { render, staticRenderFns } from "./ViewDrawers.vue?vue&type=template&id=6e0aaf36"
import script from "./ViewDrawers.vue?vue&type=script&lang=js"
export * from "./ViewDrawers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports